import { getButtonStylesWithAccentColor, getSolidButtonStylesWithAccentAndTextColor, useColorPaletteProvider } from '@apps/guest';
import { getButtonOutlineStylesWithAccentColorAndTextColor } from '@apps/guest/packages/layout-engine/layouts/layout.utils';
import { useTheme } from '@withjoy/joykit';

// Gets nav button styles.
// Uses guest site colors if available, otherwise falls back to default theme colors.
export const useNavButtonStyles = (guestStyles?: ReturnType<typeof useColorPaletteProvider>) => {
  const { colors } = useTheme();

  let accentColor = colors.newUIBrandPrimary;
  let pageFontColor = colors.white;

  if (guestStyles?.pageFontColor && guestStyles?.accentColor) {
    pageFontColor = guestStyles.pageFontColor;
    accentColor = guestStyles.accentColor;
  }

  const solidButtonStyles = getSolidButtonStylesWithAccentAndTextColor(accentColor, pageFontColor);
  const ghostButtonStyles = getButtonStylesWithAccentColor(accentColor);
  const outlineButtonStyles = getButtonOutlineStylesWithAccentColorAndTextColor(accentColor, pageFontColor);

  return { solidButtonStyles, ghostButtonStyles, outlineButtonStyles };
};
